import { useMemo } from 'react';
import { Button, Icon } from '@mercator-gcp/grout';
import { useNavigate } from 'react-router-dom';
import Dropdown from 'components/elements/Dropdown';
import DropdownItem from 'components/elements/Dropdown/DropdownItem';
import { usePolygonBounds, useDashboardGroupId } from 'state/dashboard';
import { buildProjectMapURLWithParams } from 'utils/navigation';

const CustomMapAreaDropdown = () => {
  const [polygonBounds] = usePolygonBounds();
  const navigate = useNavigate();
  const [groupId] = useDashboardGroupId();

  const redirectToMapView = () => {
    if (!groupId) {
      return;
    }
    navigate(buildProjectMapURLWithParams({ groupId: Number(groupId) }));
  };

  const statusLabel = useMemo(() => {
    return polygonBounds ? 'DEFINED' : '';
  }, [polygonBounds]);

  return (
    <Dropdown title="Custom Map Area" filterCount={statusLabel}>
      <DropdownItem>
        {polygonBounds ? (
          <Button
            variant="secondary"
            onClick={redirectToMapView}
            startAdornment={<Icon name={Icon.Name.PolygonArea} />}
          >
            Edit area on map
          </Button>
        ) : (
          <Button
            variant="functional"
            onClick={redirectToMapView}
            startAdornment={<Icon name={Icon.Name.PolygonArea} />}
          >
            Define area on map
          </Button>
        )}
      </DropdownItem>
    </Dropdown>
  );
};

export default CustomMapAreaDropdown;
